<template>
  <div class="survey__answer survey__answer--open">
    <div class="d-flex">
      <input
        type="text"
        class="form-control"
        v-model="answer"
        placeholder="Jouw antwoord..."
      >

      <button
        class="btn btn--secondary ml-2"
        type="button"
        @click="() => onAnswer([null, answer])"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24.68" height="21.83">
          <path d="M0 12.88V8.95a1.18 1.18 0 0 1 1.18-1.18h11.4V1.18A1.18 1.18 0 0 1 14.6.34l9.74 9.74a1.18 1.18 0 0 1 0 1.67l-9.74 9.73a1.18 1.18 0 0 1-2.01-.83v-6.59H1.18A1.18 1.18 0 0 1 0 12.88Z" fill="#fff" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
        answer: '',
    };
  },

  methods: {
    ...mapActions([
      'onAnswer',
    ]),
  },
};
</script>
